import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockBehaviorDataType } from "../../../../../enums/SDKDocsBlockBehaviorDataType";
import { DocsBlockBehaviorSelectionType } from "../../../../../enums/SDKDocsBlockBehaviorSelectionType";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { TokenType } from "../../../../../enums/SDKTokenType";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.token-color-ramps";
const name = "Color ramps";
const icon = "https://cdn-assets.supernova.io/blocks/icons/color-ramp.svg";
const descriptionShort = "The best way to display colors";
const keywords = [
    "tokens",
    "ramp",
    "shades",
    "palette",
    "spectrum",
    "stack",
    "range",
    "swatch",
];
const descriptionFull = "The best way to display colors";
const docsUrl = "https://learn.supernova.io";
/**
 * 2. Block properties
 */
const properties = {
    tokens: b.tokenProperty({
        id: "tokens",
        name: "Tokens",
        options: {
            allowedTypes: [TokenType.color],
            allowPropertySelection: false,
            allowThemeSelection: true,
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.tokens],
    image: "https://cdn-assets.supernova.io/blocks/variants/tokens-color-stack.svg",
    appearance: {
        isEditorPresentationDifferent: true,
    },
    maxColumns: 2,
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.tokens],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.dataBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.token,
    description: descriptionShort,
    searchKeywords: keywords,
    dataType: DocsBlockBehaviorDataType.token,
    selectionType: DocsBlockBehaviorSelectionType.entityAndGroup,
    item: blockItem,
    onboarding: b.onboarding({
        helpText: descriptionFull,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as ColorRamps };
